import {
  all,
  call,
  put,
  select,
  takeEvery,
} from 'redux-saga/effects';

import { listingApi } from '../../api';
import {
  errorHandler, successHandler,
} from '../../libs/ga';
import {
  cloneDeep,
  forEach,
} from '../../libs/lodash';

import {
  BOOKSHELF,
} from './constants';

function* storeBookshelf(data = {}, merge = true) {
  yield put({
    type: BOOKSHELF.update,
    data,
    merge,
  });
}

function* fetchBookshelf({
  data,
}) {
  yield* storeBookshelf(data);
}

function* updateBookshelf({
  data, onSuccess,
}) {
  try {
    const {
      _id,
      ...rest
    } = data;
    if (_id) {
      yield call(() => new Promise((resolve, reject) => {
        listingApi.update({
          collection: 'bookshelf',
          payload: {
            _id,
            data: rest,
          },
        }).then(() => resolve(true))
          .catch((error) => reject(error));
      }));
      yield* storeBookshelf({
        [data._id]: data,
      });
    } else {
      const {
        newData,
      } = yield call(() => new Promise((resolve, reject) => {
        listingApi.create({
          collection: 'bookshelf',
          payload: {
            data,
          },
        }).then((res) => resolve(res.data))
          .catch((err) => reject(err));
      }));
      yield* storeBookshelf({
        [newData._id]: newData,
      });
    }
    successHandler('Thành công', 'Cập nhật thành công', onSuccess);
  } catch (error) {
    yield* storeBookshelf();
    errorHandler('Thất bại', error);
  }
}

function* removeBookshelf({
  _id,
}) {
  const {
    bookshelf,
  } = yield select();
  try {
    yield call(() => new Promise((resolve, reject) => {
      listingApi.remove({
        collection: 'bookshelf',
        payload: {
          _id,
        },
      }).then(() => resolve(true))
        .catch((error) => reject(error));
    }));

    const newData = cloneDeep(bookshelf.data);
    delete newData[_id];
    yield* storeBookshelf(newData, false);

    successHandler('Thành công', 'Xóa thành công');
  } catch (error) {
    yield* storeBookshelf();
    errorHandler('Thất bại', error);
  }
}

function* importBookshelf({
  data = [],
}) {
  yield call(() => new Promise((resolve, reject) => {
    listingApi.importData({
      collection: 'bookshelf',
      payload: {
        data,
      },
    }).then(() => resolve(true))
      .catch((err) => reject(err));
  }));
  const {
    bookshelf,
  } = yield select();
  const newData = cloneDeep(bookshelf.data);
  forEach(
    (obj) => {
      newData[obj._id] = obj;
    },
    data,
  );
  yield* storeBookshelf(newData);
  successHandler('Thành công', 'Cập nhật thành công');
}

export default function* bookshelfSaga() {
  yield all([
    yield takeEvery(BOOKSHELF.handlers.fetch, fetchBookshelf),
    yield takeEvery(BOOKSHELF.handlers.update, updateBookshelf),
    yield takeEvery(BOOKSHELF.handlers.import, importBookshelf),
    yield takeEvery(BOOKSHELF.handlers.remove, removeBookshelf),
  ]);
}
